import React from 'react';

const About = () => {
    return (
        <div>
            <h1 className='text-5xl font-bold mt-20
            text-sky-600'>THANKS FOR VISITING</h1>
        </div>
    );
};

export default About;